export default "__VITE_ASSET__DQFx5NAR__"